/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import { ActionMenuItemProps } from '../../../../shared/views/ActionMenu/ActionMenu';
import PublicIcon from '@mui/icons-material/Public';
import Brightness3Icon from '@mui/icons-material/Brightness3';
import ActionMenuItemView from '../../../../shared/views/ActionMenu/ActionMenuItem.view';
import DialogActionView from '../../../../shared/views/ActionMenu/DialogAction.view';
import { Grid, Typography } from '@mui/material';

interface Props extends ActionMenuItemProps {
	text: string;
	userFirstName: string;
	isInParallelWorld: boolean;
	handleSave: () => void;
}

class ChangeStatusActionView extends Component<Props> {
	render(): JSX.Element {
		const { text, isInParallelWorld, userFirstName, handleSave, renderMenuItem } = this.props;
		return isInParallelWorld ? (
			<ActionMenuItemView
				renderMenuItem={renderMenuItem}
				icon={<PublicIcon color="primary" />}
				text={text}
				action={handleSave}
			/>
		) : (
			<DialogActionView
				itemProps={{
					renderMenuItem,
					icon: <Brightness3Icon color="primary" />,
					text
				}}
				dialogProps={{
					danger: false,
					titleText: 'In die Parallelwelt schicken',
					saveButtonText: 'Ab in die Parallelwelt!',
					handleSave
				}}
			>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography>
							{`In der Parallelwelt kann ein Benutzer alle Beiträge lesen. Alles, was er schreibt, ist jedoch nur für
							Personen in der Parallelwelt sichtbar.`}
						</Typography>
						<p>
							<Typography>{`Soll ${userFirstName} wirklich in die Parallelwelt geschickt werden?`}</Typography>
						</p>
					</Grid>
				</Grid>
			</DialogActionView>
		);
	}
}

export default ChangeStatusActionView;
